/**
 * @generated SignedSource<<5aa5630c4972e62381cd3c8e035edac0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type dependencies_useCitiesModalQuery$variables = {
  prefecture: string
  region: string
  choice: string
}
export type dependencies_useCitiesModalQuery$data = {
  readonly listCitiesWithCemeteryCount: {
    readonly items: ReadonlyArray<{
      readonly cityId: number
      readonly name: string
      readonly cemeteryCount: number
    }>
  }
}
export type dependencies_useCitiesModalQuery = {
  variables: dependencies_useCitiesModalQuery$variables
  response: dependencies_useCitiesModalQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'choice'
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'prefecture'
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'region'
    },
    v3 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                items: [
                  {
                    kind: 'Variable',
                    name: 'choices.0',
                    variableName: 'choice'
                  }
                ],
                kind: 'ListValue',
                name: 'choices'
              }
            ],
            kind: 'ObjectValue',
            name: 'cemeteryFilter'
          },
          {
            fields: [
              {
                fields: [
                  {
                    kind: 'Variable',
                    name: 'eq',
                    variableName: 'prefecture'
                  }
                ],
                kind: 'ObjectValue',
                name: 'prefectureRoma'
              },
              {
                fields: [
                  {
                    kind: 'Variable',
                    name: 'eq',
                    variableName: 'region'
                  }
                ],
                kind: 'ObjectValue',
                name: 'regionCode'
              }
            ],
            kind: 'ObjectValue',
            name: 'filter'
          },
          {
            kind: 'Literal',
            name: 'limit',
            value: 999
          }
        ],
        concreteType: 'CityWithCemeteryCountConnection',
        kind: 'LinkedField',
        name: 'listCitiesWithCemeteryCount',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'CityWithCemeteryCount',
            kind: 'LinkedField',
            name: 'items',
            plural: true,
            selections: [
              {
                alias: 'cityId',
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'name',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'cemeteryCount',
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'dependencies_useCitiesModalQuery',
      selections: v3 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v1 /*: any*/, v2 /*: any*/, v0 /*: any*/],
      kind: 'Operation',
      name: 'dependencies_useCitiesModalQuery',
      selections: v3 /*: any*/
    },
    params: {
      cacheID: 'eb8b5952a3a78b1a2f9e73f39b1b9615',
      id: null,
      metadata: {},
      name: 'dependencies_useCitiesModalQuery',
      operationKind: 'query',
      text: 'query dependencies_useCitiesModalQuery(\n  $prefecture: String!\n  $region: String!\n  $choice: String!\n) {\n  listCitiesWithCemeteryCount(filter: {regionCode: {eq: $region}, prefectureRoma: {eq: $prefecture}}, cemeteryFilter: {choices: [$choice]}, limit: 999) {\n    items {\n      cityId: id\n      name\n      cemeteryCount\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = 'd6db7e60f3743e365a34bbed92684752'

export default node
